import gql from 'graphql-tag';

export const QUERY_PROFESSIONALS_DOWNLOADS_ASSET_CATEGORIES = gql`
  query DownloadsAssetCategories($assetCategoryKeys: [String!]!) {
    assetCategories(where: { key: $assetCategoryKeys }) {
      id
      name_en
      name_de
      key
    }
  }
`;

export const QUERY_PROFESSIONALS_DOWNLOADS_ASSETS = gql`
  query DownloadsAssets($assetCategoryIds: [String!]!) {
    assets(where: { asset_category: $assetCategoryIds }) {
      id
      type
      name
      subtype
      channels
      asset_category {
        id
        name_en
        name_de
        key
      }
      file {
        formats
        caption
        name
        url
        size
        ext
      }
    }
  }
`;
